import { render, staticRenderFns } from "./ProductOverviewGallery.vue?vue&type=template&id=6ef61e6a"
import script from "./ProductOverviewGallery.vue?vue&type=script&lang=js"
export * from "./ProductOverviewGallery.vue?vue&type=script&lang=js"
import style0 from "./ProductOverviewGallery.vue?vue&type=style&index=0&id=6ef61e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports